<div class="auth-wrapper flex align-vertical column"><div class="auth-box"><slot></slot></div></div>